import {getAreaTree} from '@/api/admin'
import areas from '@/utils/area.min.json'
const state = () => ({
  // 区域（不含港）
  areaList: areas
})
// getters
const getters = {
  // 获取区域大全列表
  areaList: state => {
    return state.areaList
  }
}

// actions
const actions = {
  getAreaList({ commit, state }){
    getAreaTree().then(res=>{
      if(res.data&&res.data.length>0){
        let _data=res.data
        recursionArea(_data)
        console.log(JSON.stringify(_data))
        commit('SET_AREALIST', _data)
      }
    })
  }
}
// mutations
const mutations = {
  SET_AREALIST:(state, areaList) => {
    state.areaList = areaList
  }
}
function recursionArea(data){
  data.forEach(item => {
    if(item.children&&item.children.length>0){
      recursionArea(item.children)
    }else{
      delete item.children
    }
  });
  
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/area.js